import { render, staticRenderFns } from "./TourManagement.vue?vue&type=template&id=4a6e45d6&"
import script from "./TourManagement.vue?vue&type=script&lang=js&"
export * from "./TourManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports